/// <reference path="../../node_modules/@types/jquery/index.d.ts" /> 

declare const $zopim: any;
declare const YT: any;

$(document).ready(() => {

    let zopimLoaded = false;

    const $chatButton = $('.chat-button');
    $chatButton.on('click', () => {
        if (!zopimLoaded) {
            const el = document.createElement('script');
            el.src = '/dist/js/snapengage.js';
            el.async = false;
            document.body.appendChild(el);
        } else {
            $zopim.livechat.window.show();
        }
    });

    const $btnYoutubePlayer = $("#play_vid");
    $btnYoutubePlayer.on('click', () => {
        $("#play_vid").parent().addClass('playing');

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        tag.async = false;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        tag.addEventListener('load', () => {
            setTimeout(() => {
                onYouTubeIframeAPIReady();
            }, 1000)
        });
    });

    var player;
    function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
            height: '250',
            width: '100%',
            videoId: 'mH0yRzoG3ck',
            events: {
                'onReady': onPlayerReady,
            }
        });
    }

    function onPlayerReady(event) {
        $("#play_vid").addClass('hidden');
        $(".video-player").removeClass('hidden');
        event.target.playVideo();
    }

    (window as any).newmain = true;

});